import React, { useState, useEffect } from 'react';
import Fade from '@material-ui/core/Fade';
import AdminMain from './components/adminModule/AdminMain';

const Admin = () => {

    const [step, setStep] = useState(1);
    const [showFade, setShowFade] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [step]);

    const renderStepScreen = () => {
        switch (step) {
            case 1:
              return <AdminMain />;

            default:
              return <div></div>;
        }
    }

    return (
        <div style={{position: 'realtive'}}>
            <Fade in={showFade} timeout={{enter: 600, exit: 0}} disableStrictModeCompat={true}>
              {renderStepScreen()}
            </Fade>
        </div>
    )
}

export default Admin;
